<template>
	<div class="bg-[#F5F9FA] h-screen pt-[43px] box-border">
		<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto mb-[40px] flex items-center">
			<img @click="backIndex()" src="@/static/image/icon12.png" class="cursor-pointer w-[24px] h-[24px]" alt="" />
			<label @click="backIndex()"
				class="cursor-pointer text-[18px] text-[#000000]">{{langInfo.login_home}}</label>
		</div>
		<div class="2xl:max-w-3xl relative xl:max-w-3xl mx-auto bg-white rounded-[10px] flex ">
			<!-- <div
				class="w-[450px] h-[700px]  rounded-[10px] leftContent text-white flex  flex-col items-center pt-[6%] pl-[40px] pr-[40px] box-border">
				<img src="@/static/image/logo.png" class="w-[140px] h-[140px] mb-[80px]" alt="" srcset="" />
				<div class="text-[36px]   font-bold mb-[20px]">
					{{langInfo.login_hello}}，
					{{langInfo.login_welcome}}
				</div>
				
			</div> -->
			
			<div @click="goLogin()"
				class=" absolute top-[20px] text-[#3894FF] right-[20px]  box-border cursor-pointer     text-[18px] font-semibold  text-center">
				{{langInfo.reg_login}}
			</div>
			
			<!-- 注册页面 -->
			<div class="min-h-[700px] relative mx-auto pb-[20px] box-border flex  flex-col items-center pt-[6%] box-border"
				style="">
				
			
				
				<div class="text-[42px] text-[#000000] font-bold mb-[20px] ">
					{{langInfo.login_forget}}
				</div>
				
				
				<div class="w-[520px] mx-auto ">
					<div class="pr-[40px]">
						<div class="mb-[30px] flex  text-[16px] text-[#101010]">
							<div @click="selectLoginMethod(1)" :class="loginMethod==1?'active':''"
								class="loginTitle  cursor-pointer relative mr-[60px]">
								{{langInfo.login_email}}
							</div>
							<div @click="selectLoginMethod(2)" :class="loginMethod==2?'active':''"
								class="loginTitle cursor-pointer relative mr-[60px]">
								{{langInfo.login_tel}}
							</div>

						</div>
						<div v-if="loginMethod==1"
							class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon80.png" class="w-[18px] h-[18px]" alt="" />
							<input v-model="email" :placeholder="langInfo.login_email_tip" class="text-[16px]"
								style="width: calc(100% - 38px);" />
						</div>
						<div v-else-if="loginMethod==2"
							class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon13.png" class="w-[18px] h-[18px]" alt="" />
							<input v-model="phone" :placeholder="langInfo.login_tel_tip" class="text-[16px]"
								style="width: calc(100% - 38px);" />
						</div>
						<div v-if="loginMethod==1||loginMethod==2"
							class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon14.png" class="w-[18px] h-[18px]" alt="" />
							<input v-model="password" type="password"
								:placeholder="langInfo['Please set a new password']" class="text-[16px]"
								style="width: calc(100% - 38px);" />
						</div>
						<div v-if="loginMethod==1||loginMethod==2"
							class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon14.png" class="w-[18px] h-[18px]" alt="" />
							<input v-model="nextPassword" type="password"
								:placeholder="langInfo['Please set a new password again']" class="text-[16px]"
								style="width: calc(100% - 38px);" />
						</div>

						<div v-if="loginMethod==1||loginMethod==2"
							class="flex items-center justify-between mb-[20px]  bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
							<img src="@/static/image/icon15.png" class="w-[18px] h-[18px]" alt="" />
							<input v-model="code" :placeholder="langInfo.reg_code_tip" class="text-[16px]"
								style="width: calc(100% - 164px);" />
							<div @click="getCodeClick()"
								class="w-[126px] cursor-pointer text-[18px] text-[#3894FF] font-semibold text-right"
								style="">
								{{getCodeText}}
							</div>
						</div>
					</div>
					<div v-if="loginMethod==1" class=" mb-[24px] text-[#B8B8B8]">
						<label class="text-[#FF0000]">{{langInfo.reg_tip}}：</label>{{langInfo.reg_tip_content}}
					</div>
					<div v-else-if="loginMethod==2" class=" mb-[24px] text-[#B8B8B8]">
						<label class="text-[#FF0000]">{{langInfo.login_tip}}：</label>{{langInfo.login_tip_content}}
					</div>
					<div @click="submitBtn()"
						class="w-[248px] h-[64px] cursor-pointer mb-[30px] mx-auto leading-[64px] rounded-[50px] bg-[#3894FF] text-center text-white text-[18px] font-bold">
						{{langInfo.confirm_modification}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loginMethod: 1, //1邮箱 2手机号 
				email: '',
				phone: '',
				password: "",
				nextPassword: '',
				code: '', //验证码

				getCodeText: '', //获取验证码
				getCodeisWaiting: false,

				isCheck: true,
				checkActive: require('../../static/image/icon17.png'),
				check: require('../../static/image/icon16.png'),

				langInfo: '',
			}
		},
		mounted() {
			this.langInfo = this.$store.getters['lang/getLangList']
			console.log("langInfo===");
			console.log(this.langInfo);

			this.getdict_data()
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.getCodeText = this.langInfo.reg_get_code
					document.title = this.langInfo.pc_name+'-'+this.langInfo.login_forget
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			// 选择登录方式
			selectLoginMethod(method) {
				this.loginMethod = method;
				this.getCodeisWaiting = false;
				this.getCodeText = this.langInfo.reg_get_code
				clearInterval(this.Timer)
				this.Timer = null
			},
			backIndex() {
				this.$router.replace({ path: '/' })
			},
			// 去登录
			goLogin() {
				this.$router.push({ path: '/login' })
			},
			// 获取验证码
			getCodeClick() {
				if (this.loginMethod == 1) {
					if (!this.email) {
						this.$message({
							message: this.langInfo.login_email_tip,
							type: 'warning'
						});
						return
					}
				}
				if (this.getCodeisWaiting) {
					return
				}
				this.getCodeText = this.langInfo.sending //发送验证码
				this.getCodeisWaiting = true;

				this.getCode()
			},
			getCodeTimer() {
				let holdTime = 60; //定义变量并赋值
				// this.getCodeText = "重新获取60s"
				this.Timer = setInterval(() => {
					if (holdTime <= 0) {
						this.getCodeisWaiting = false;
						this.getCodeText = this.langInfo.reg_get_code
						clearInterval(this.Timer); //清除该函数
						return; //返回前面
					}
					this.getCodeText = this.langInfo.re_obtain + holdTime + "s"
					holdTime--;
				}, 1000)
			},

			getCode() {
				if (this.loginMethod == 1) {
					this.$api.sendResetPasswordCode({
						email: this.email,
						type: 'reset_password_code'
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'warning'
						})
						this.getCodeTimer()
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				} else if (this.loginMethod == 2) {
					this.$api.send({
						phone: this.phone,
						user_register: 'user_retrieve_pwd'
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'warning'
						})
						this.getCodeTimer()
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				}

			},
			// 确认修改
			submitBtn() {
				if (this.loginMethod == 1) {
					this.emailPass()
				} else if (this.loginMethod == 2) {
					this.phonePass()
				}
			},
			phonePass() {
				if (!this.phone) {
					this.$message({
						message: this.langInfo.login_tel_tip,
						type: 'warning'
					});
					return
				}

				const reg = /^1[3456789]\d{9}$/;
				if (!reg.test(this.phone)) {
					this.$message({
						message: this.langInfo.wrong_phone_number,
						type: 'warning'
					});
					return
				}

				if (!this.password) {
					this.$message({
						message: this.langInfo.login_password_tip,
						type: 'warning'
					});
					return
				}
				if (!this.nextPassword) {
					this.$message({
						message: this.langInfo.reg_password_tip,
						type: 'warning'
					});
					return
				}
				if (this.password != this.nextPassword) {
					this.$message({
						message: this.langInfo.entered_passwords_differ,
						type: 'warning'
					});
					return
				}
				if (!this.code) {
					this.$message({
						message: this.langInfo.reg_code_tip,
						type: 'warning'
					});
					return
				}

				this.$api.resetPasswordBymobile({
					mobile: this.phone,
					code: this.code,
					new_password: this.password,
					confirm_password: this.nextPassword
				}).then((res) => {
					console.log(res);

					this.$message({
						message: res.msg,
						type: 'success'
					});

					this.$api.login({
						mobile: this.phone,
						password: this.password,
						type: 2,
					}).then((res) => {
						console.log(res);
						localStorage.setItem('token', res.data.token)
						setTimeout(() => {
							const redirectUrl = localStorage.getItem('loginRedirect');
							if (redirectUrl) {
								localStorage.removeItem('loginRedirect'); // 删除记录
								this.$router.push(redirectUrl);
							} else {
								this.$router.push(
								'/studyCenter/newStudyCenter'); // 使用完整路径

								// this.$router.push('/'); // 使用完整路径
							}
						}, 800)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})


			},
			emailPass() {
				if (!this.email) {
					this.$message({
						message: this.langInfo.login_email_tip,
						type: 'warning'
					});
					return
				}
				if (!this.password) {
					this.$message({
						message: this.langInfo.login_password_tip,
						type: 'warning'
					});
					return
				}
				if (!this.nextPassword) {
					this.$message({
						message: this.langInfo.reg_password_tip,
						type: 'warning'
					});
					return
				}
				if (this.password != this.nextPassword) {
					this.$message({
						message: this.langInfo.entered_passwords_differ,
						type: 'warning'
					});
					return
				}
				if (!this.code) {
					this.$message({
						message: this.langInfo.reg_code_tip,
						type: 'warning'
					});
					return
				}

				this.$api.resetPasswordByEmail({
					email: this.email,
					code: this.code,
					new_password: this.password,
					confirm_password: this.nextPassword
				}).then((res) => {
					console.log(res);

					this.$message({
						message: res.msg,
						type: 'success'
					});

					this.$api.login({
						email: this.email,
						password: this.password,
						type: 1,
					}).then((res) => {
						console.log(res);
						localStorage.setItem('token', res.data.token)
						setTimeout(() => {
							const redirectUrl = localStorage.getItem('loginRedirect');
							if (redirectUrl) {
								localStorage.removeItem('loginRedirect'); // 删除记录
								this.$router.push(redirectUrl);
							} else {
								this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
								// this.$router.push('/'); // 使用完整路径
							}
						}, 800)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})


				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			}
		}
	}
</script>

<style scoped>
	.leftContent {
		background: linear-gradient(137.58deg, rgba(56, 148, 255, 1) -0.52%, rgba(56, 148, 255, 0.6) 112.81%);
	}

	.loginTitle.active::after {
		content: "";
		position: absolute;
		width: 42px;
		height: 8px;
		background-color: rgba(41, 121, 255, 1);
		bottom: -12px;
		left: 50%;
		transform: translateX(-50%);

	}

	input {
		border: none;
		background-color: transparent;
	}

	input:focus {
		outline: none;
	}

	input::placeholder {
		color: #CCCCCC;
		/* 例如，设置为灰色 */
	}
</style>